import { render, staticRenderFns } from "./UnauthorizedView.vue?vue&type=template&id=8828b31a&scoped=true"
import script from "./UnauthorizedView.vue?vue&type=script&lang=js"
export * from "./UnauthorizedView.vue?vue&type=script&lang=js"
import style0 from "./UnauthorizedView.vue?vue&type=style&index=0&id=8828b31a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8828b31a",
  null
  
)

export default component.exports